import "./ShowNotification.css";

import { Breadcrumb, Button, message, Tag } from "antd";
import { BiEdit } from "react-icons/bi";
import { BsTrash } from "react-icons/bs";
import { Link, useLocation, useNavigate } from "react-router-dom";

import { deleteNotification, useAppSelector } from "../../../_lib/_store";

export const ShowNotificationPage = () => {
  const [messageApi, contextHolder] = message.useMessage();
  const { isLoading } = useAppSelector((state) => state.notification);

  const navigate = useNavigate();
  const { state } = useLocation();

  const notificationObj = state?.notification;

  const handleDelete = async () => {
    const res = await deleteNotification(messageApi, notificationObj?.id);
    if (res) {
      navigate("/notification");
    }
  };

  return (
    <>
      {contextHolder}
      <div className="createCategory">
        <Breadcrumb
          items={[
            {
              title: <Link to="/dashboard">Dashboard</Link>,
            },
            {
              title: <Link to="/notification">Notification</Link>,
            },
            {
              title: "Show",
            },
          ]}
        />

        <div className="titleHeader">
          <h2 className="title">Show</h2>
          <div className="actionButton">
            <Button
              icon={<BiEdit />}
              size="large"
              onClick={() =>
                navigate(`/notification/edit`, {
                  state: { notification: state?.notification },
                })
              }
            >
              Edit
            </Button>
            <Button
              icon={<BsTrash />}
              size="large"
              onClick={handleDelete}
              loading={isLoading}
            >
              Delete
            </Button>
          </div>
        </div>

        <div className="form">
          <div className="row">
            <p className="label">Notification ID</p>
            <p className="value">{notificationObj?.id}</p>
          </div>
          <div className="row">
            <p className="label">Title</p>
            <p className="value">{notificationObj?.title}</p>
          </div>
          <div className="row">
            <p className="label">Message</p>
            <p className="value" style={{ whiteSpace: "pre-wrap" }}>
              {notificationObj?.message}
            </p>
          </div>
          <div className="row">
            <p className="label">Type</p>
            <p className="value">
              <Tag
                color={
                  notificationObj?.type === "Success"
                    ? "green"
                    : notificationObj?.type === "Warning"
                      ? "orange"
                      : notificationObj?.type === "Error"
                        ? "red"
                        : "blue"
                }
              >
                {notificationObj?.type}
              </Tag>
            </p>
          </div>
          <div className="row">
            <p className="label">Target Audience</p>
            <p className="value">{notificationObj?.targetAudience}</p>
          </div>
          <div className="row">
            <p className="label">Send Push Notification</p>
            <p className="value">
              <Tag
                color={notificationObj?.sendPushNotification ? "green" : "red"}
              >
                {notificationObj?.sendPushNotification ? "Yes" : "No"}
              </Tag>
            </p>
          </div>
          <div className="row">
            <p className="label">Send Email Notification</p>
            <p className="value">
              <Tag
                color={notificationObj?.sendEmailNotification ? "green" : "red"}
              >
                {notificationObj?.sendEmailNotification ? "Yes" : "No"}
              </Tag>
            </p>
          </div>
        </div>
      </div>
    </>
  );
};
